module.exports = __webpack_public_path__ + "static/img/1.a0b42bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/1.png
// module id = zypc
// module chunks = 0